import { Component, OnInit, ElementRef, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';

import { VesselsSearchService } from './vessels-search.service';
import { LogService, Vessel } from './../../shared';

@Component({
  selector: 'vessels-search',
  template: require('./vessels-search.component.html'),
  styles: [require('./vessels-search.component.scss')],
  providers: [VesselsSearchService],
  host: {
    '(document:click)': 'onClick($event)'
  }
})
export class VesselsSearchComponent implements OnInit {
  @Output() close: EventEmitter<any> = new EventEmitter();

  private searchTermStream: Subject<any> = new Subject<any>();
  searchTerm: string = '';
  item: Vessel = null;

  itemsSub: any;
  items = Array<Vessel>();

  constructor(private logger: LogService, private router: Router, private service: VesselsSearchService) {
    // Do stuff
  }

  ngOnInit() {
    this.logger.log('vessels-search.component', 'ngOnInit', 'Hello Vessels Search');
    this.initSearchBox();

    this.loadCache();
  }

  initSearchBox() {
    this.itemsSub = this.searchTermStream
      .debounceTime(100)
      .distinctUntilChanged()
      .switchMap((term: string) => this.service.getVessels(term)).subscribe((vessels: Array<Vessel>) => {
        this.items = vessels;
      });
  }

  loadCache() {
    if (sessionStorage.getItem('vessels-search-term')) {
      this.searchTerm = sessionStorage.getItem('vessels-search-term');
    }
  }

  onClick($event) {
    if ($event.target.id === 'searchbox' && !this.service.autoOn) {
      this.auto();
    } else if ($event.target.id !== 'searchbox' && this.service.autoOn) {
      this.service.autoOn = false;
    }
  }

  search() {
    if (this.item !== null) {
      this.close.emit({ event: event, searchType: '', location: 'header' });
      this.router.navigate(['/vessels', this.item.id]);
    } else if (sessionStorage.getItem('vessels-search-item-id')) {
      var vesselsId = sessionStorage.getItem('vessels-search-item-id');
      this.close.emit({ event: event, searchType: '', location: 'header' });
      this.router.navigate(['/vessels', vesselsId]);
    }

    sessionStorage.setItem('vessels-search-term', this.searchTerm);
    sessionStorage.setItem('vessels-search-item-id', this.item.id.toString());
  }

  set(item: Vessel) {
    this.service.autoOn = false;
    this.logger.log('vessels-search', 'set', item);
    this.searchTerm = item.name;
    this.item = item;
  }

  auto(event: KeyboardEvent = null) {
    this.logger.log('vessels-search', 'auto', this.service.noResult);
    if (event != null) {
      this.capture(event.keyCode);
    }

    if (this.searchTerm.length < 3) {
      if (this.service.app.vessels.length === 0) {
        this.service.autoOn = false;
      } else {
        this.service.autoOn = true;
      }
    }
    else {
      if (this.service.autoOn === false) {
        this.service.startSearch();
      }
      this.searchTermStream.next(this.searchTerm);
      this.logger.log('vessels-search', 'auto else', this.service.autoOn);
    }
  }

  selectText($event) {
    $event.target.select();
  }

  capture (keyCode: number) {
    switch (keyCode) {
      case 9:
        this.autocomplete();
        break;
      case 13:
        this.autocomplete();
        this.search();
        break;
      case 35:
        this.highlight('up');
        break;
      case 40:
        this.highlight('down');
        break;
    }
  }

  autocomplete() {
    try {
      if (this.items != null && this.items.length != 0) {
        this.set(this.items[0]);
      }
    } catch (ex) {
      this.logger.log('ports-search', 'autocomplete ex', ex);
    }
  }

  highlight(direction: string = 'down') {
    if (this.items == null || this.items.length == 0) {
      return;
    }

    // expand to highlight items in the list
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/search/vessels-search/vessels-search.component.ts